import { ApiClientProps } from "hooks/useApi";
import { Dayjs } from "dayjs";

export interface GeneratePayload {
    partnerVenueIds: string[];
    from: string | Date | Dayjs;
    to: string | Date | Dayjs;
    accessToken: string | undefined;
    apiClient: ApiClientProps;
}


export interface GenerateTotalCheckMatchReportByDateResponse {
    hasErrors: any;
    message: string;
    resource: {
        requestId: string;
        message: string;
    }

}


function requireAuthAndIds(accessToken?: string, ids?: string[]) {
    if (!accessToken) throw new Error("No accessToken provided.");
    if (!ids?.length) throw new Error("At least one partnerVenueId is required.");
}

export async function generateTotalCheckMatchReportByDateGeneration({
  partnerVenueIds,
  from,
  to,
  accessToken,
  apiClient,
}: GeneratePayload): Promise<GenerateTotalCheckMatchReportByDateResponse> {
    requireAuthAndIds(accessToken, partnerVenueIds);
    const body = JSON.stringify({
      fromDate: from,
      toDate: to,
      partnerVenueIds: partnerVenueIds.map(String),
    });
    const response = await apiClient.post({
      path: "middleware-admin/partners/report/generate/checkmatch/totals-bydate",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body,
    });
    return response as GenerateTotalCheckMatchReportByDateResponse;
}


